<mat-card appearance="outlined" *ngIf="payment_method_model.id && payment_methods_model.length >= 1">
    <mat-card-title>Primary Payment Method</mat-card-title>
    <mat-card-subtitle *ngIf="payment_methods_list?.length">Select your primary payment method from those
        listed.</mat-card-subtitle>

    <div class="card-grid">
        <ng-container *ngFor="let method of payment_methods_list">
            <div class="payment-card row" [class.primary-card]="method.default_account" (click)="setDefault(method)">
                <div class="account-type">
                    <span class="icon">{{ method.account_type === 'Checking' ? '🏦' : '💳' }}</span>
                    <span class="brand-text">
                        {{ ((method.ch_name_on_check??method.cc_name_on_card) ? (method.ch_name_on_check??method.cc_name_on_card) + ' - ' : '') + (method.account_type === 'Checking' ? 'Checking' : method.bin === true ? 'Debit Card' : 'Credit Card') }}
                    </span>
                    <div *ngIf="method.default_account" class="primary-check" title="Primary Payment Method">
                        <fa-icon [icon]="faCheck"></fa-icon>
                    </div>
                </div>

                <div class="row card-content">
                    <div class="card-number">
                        <span> •••• {{(method.account_type === 'Checking' ? method.ch_number_mask
                            :method.cc_number_mask)?.slice(-4)}}</span>
                    </div>
                    <div class="expiry" *ngIf="method.cc_expiration_date">
                        <span>Expires {{ method.cc_expiration_date | date: 'MM/yy' }}</span>
                    </div>
                    <div class="expiry" *ngIf="method.ch_bank_name">
                        <span>{{method.ch_bank_name.trim()}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- <span class="success-message">{{success_message}}</span> -->

</mat-card>